import React, {useState} from 'react';
import {ComputedPageItem} from '@taopix/taopix-core/dist/types/types';
import {Button, PictureIcon, TrashIcon} from '@taopix/taopix-design-system';
import {
  buttonStyles,
  cornerTypes,
} from '@taopix/taopix-design-system/dist/types/Components/Button/Button';
import {useTranslation} from 'react-i18next';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import ToolPaletteSection from '../ToolPalette/ToolPaletteSection';

export type ShapeSettingsProps = {
  sectionKey: string;
  item?: ComputedPageItem;
};

const ShapeSettings = ({sectionKey, item}: ShapeSettingsProps) => {
  const ui = useUiState();
  const {t} = useTranslation(['stubar']);
  const [showButton] = useState<boolean>(false);

  const optionButtonProps = {
    buttonStyle: (ui.state.isSmallScreen ? 'standard' : 'secondary') as buttonStyles,
    stacked: ui.state.isSmallScreen,
    corners: (ui.state.isSmallScreen ? 'square' : 'theme') as cornerTypes,
  };

  const sectionButtonClasses = [
    ...(ui.state.isSmallScreen
      ? [
          'threeButtons:w-[calc(100vw/3.5)]',
          'fourButtons:w-[calc(100vw/4.5)]',
          'fiveButtons:w-[calc(100vw/5.5)]',
          'sixButtons:w-[calc(100vw/6.5)]',
          'sevenButtons:w-[calc(100vw/7.5)]',
          'eightButtons:w-[calc(100vw/8.5)]',
        ]
      : ['']),
  ];

  return (
    <ToolPaletteSection
      buttonClasses={sectionButtonClasses.join(' ')}
      sectionKey={sectionKey}
      title={t('str_LabelShapeOptions', {ns: 'stubar'})}
      buttonIcon={<PictureIcon />}
      showButton={showButton}
      id="shapeSettingsPalette"
    >
      <Button label={t('*:str_ButtonDelete')} startIcon={<TrashIcon />} {...optionButtonProps} />
    </ToolPaletteSection>
  );
};

export default ShapeSettings;
